module.exports = __webpack_public_path__ + "static/media/icon-rank-mini-1.26d92629.png";